import { useState } from "react";
import { categories } from "@/mocks/basetaoData";

export default function CategorySection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground-900 mb-3">
              Browse Product Categories
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              Select a category below or use the dropdown to navigate directly to our main store for the best shopping experience.
            </p>
          </div>

          <div className="flex flex-col items-center gap-8">
            <div className="relative w-full max-w-md">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="w-full flex items-center justify-between px-5 py-3.5 rounded-xl bg-background-100 border border-background-200/70 text-foreground-800 text-sm font-medium hover:border-primary-300 transition-all duration-200 cursor-pointer"
              >
                <span>Choose a category...</span>
                {dropdownOpen ? (
                  <i className="ri-arrow-up-s-line text-lg w-5 h-5 flex items-center justify-center text-foreground-500 transition-transform duration-200"></i>
                ) : (
                  <i className="ri-arrow-down-s-line text-lg w-5 h-5 flex items-center justify-center text-foreground-500 transition-transform duration-200"></i>
                )}
              </button>

              {dropdownOpen && (
                <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200/70 rounded-xl shadow-lg z-30 max-h-72 overflow-y-auto">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      onClick={() => setDropdownOpen(false)}
                      className="flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors duration-150 cursor-pointer whitespace-nowrap"
                    >
                      <i className={`${cat.icon} text-base w-5 h-5 flex items-center justify-center text-foreground-400`}></i>
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 w-full">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 hover:shadow-md transition-all duration-300 cursor-pointer overflow-hidden"
                >
                  <div className="w-full h-36 overflow-hidden">
                    <img
                      src={cat.image}
                      alt={`${cat.name} category - BaseTao Spreadsheet shopping`}
                      title={`Shop ${cat.name} - BaseTao Spreadsheet`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="flex items-center gap-2 px-3 py-3">
                    <div className="w-7 h-7 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors duration-200">
                      <i className={`${cat.icon} text-sm text-accent-600 w-4 h-4 flex items-center justify-center`}></i>
                    </div>
                    <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                      {cat.name}
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}